/**
 * Created by mqamhieh on 10/17/17.
 */
(function (app) {
    app.controller('UploadApplicantModal', [
        '$scope', 'hUser', 'Upload', 'modalData', 'userServices', 'userPermissions',
        function ($scope, hUser, Upload, modalData, userServices, userPermissions) {

            $scope.close = function () {
                $scope.$hide();
            };

            var brandId = hUser.getUserContext().brand_id;

            if (modalData.job && modalData.job.Brand) {
                brandId = modalData.job.Brand.id;
            }

            $scope.loading = true;
            $scope.uploadApplicantForm = new UploadApplicantForm($scope, hUser, Upload, userServices, userPermissions);

            $scope.uploadApplicantForm.load(modalData.job, undefined, modalData.fromApplicant)
                .then(function () {
                    delete $scope.loading;
                    $scope.$digest();
                });

            $scope.save = function () {
                $scope.uploadApplicantForm.validator.validate(function (isValid) {
                    if (isValid) {
                        $scope.uploadApplicantForm.save()
                            .then(function (result) {
                                modalData.onSuccess && modalData.onSuccess(result['jobData'], result['applicant']);
                                $scope.close();
                                $scope.$digest();
                            }, function () {

                            });
                    }
                });
            };

        }]);
})(angular.module('harriApp'));